<template>
  <div>
    <b-card no-body>
      <!-- Head -->
      <table-header
        search
        search-placeholder="Cari di sini"
        search-action="setting/getSettingsList"
      >
        <template #action>
          <b-button
            v-if="canAccess('manage', 'FaqCategory')"
            variant="primary"
            :to="{ name: 'faq-categories-create'}"
          >
            + Buat Kategori FAQ
          </b-button>
        </template>
      </table-header>
      <!-- Body -->
      <b-skeleton-table
        v-if="isLoading"
        :rows="5"
        :columns="4"
      />
      <b-table
        v-else
        ref="refUserListTable"
        :items="faqCategories.data"
        responsive
        :fields="tableFields"
        primary-key="id"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        class="position-relative mh-160"
      >

        <!-- Column: Nama -->
        <template #cell(name)="data">
          {{ data.item.name }}
        </template>

        <!-- Column: Slug -->
        <template #cell(slug)="data">
          {{ data.item.slug }}
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canAccess('manage', 'FaqCategory')"
          #cell(actions)="data"
        >
          <div class="text-nowrap text-right">
            <!-- Dropdown -->
            <table-action
              :actions="tableAction"
              :data="data"
            />
          </div>
        </template>

      </b-table>
      <!-- Footer -->
      <div class="mx-2 mb-2">
        <pagination
          :data="faqCategories.meta"
          action="faqCategory/getCategoriesFaq"
        />
      </div>
    </b-card>

    <b-modal
      v-if="canAccess('manage', 'FaqCategory')"
      id="modal-delete"
      title="Apakah anda yakin"
      @hidden="deletedData = ''"
    >
      Ingin Menghapus Kategori FAQ ini?
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-secondary"
          :disabled="isDeleting"
          @click="cancel()"
        >
          Batalkan
        </b-button>
        <b-button
          variant="danger"
          :disabled="isDeleting"
          @click.prevent="handleDelete"
        >
          <b-spinner
            v-if="isDeleting"
            small
            label="Spinning"
          />
          {{ isDeleting ? 'Menghapus' : 'Ya, Hapus' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Ripple from 'vue-ripple-directive'
import {
  BSkeletonTable,
  BButton,
  BCard,
  BTable,
  VBTooltip,
  BModal,
} from 'bootstrap-vue'
import Pagination from '@/layouts/components/custom/Pagination.vue'
import TableHeader from '@/layouts/components/custom/TableHeader.vue'
import TableAction from '@/layouts/components/custom/TableAction.vue'

export default {
  components: {
    BButton,
    BSkeletonTable,
    BCard,
    BTable,
    BModal,
    Pagination,
    TableHeader,
    TableAction,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      tableFields: [
        { key: 'name', label: 'Nama' },
        { key: 'slug', label: 'Slug' },
        { key: 'actions', label: '', thStyle: { width: '1%' } },
      ],
      isPending: false,
      isDeleting: false,
      deletedData: '',
    }
  },
  computed: {
    ...mapState('faqCategory', ['faqCategories', 'isLoading']),
    query() {
      return this.$route.query
    },
    tableAction() {
      return [
        {
          access: null,
          to: 'faq-categories-edit|id:id',
          action: '',
          icon: 'EditIcon',
          title: 'Edit',
        },
        {
          access: null,
          to: null,
          action: data => { this.deleteConfirmation(data.id) },
          icon: 'TrashIcon',
          title: 'Hapus',
        },
      ]
    },
  },
  async created() {
    await this.getCategoriesFaq(this.query)
  },
  methods: {
    ...mapActions('faqCategory', ['getCategoriesFaq', 'deleteCategoriesFaq']),
    deleteConfirmation(value) {
      this.$bvModal.show('modal-delete')
      this.deletedData = value
    },
    async handleDelete() {
      this.isDeleting = true
      await this.deleteCategoriesFaq({ faqCategoryId: this.deletedData })
      this.isDeleting = false
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>
